
<div class="header-toolbar">
  <h1>
    Historique
  </h1>
</div>

<!-- Toolbar -->
<div class="main btn-toolbar">

  <div class="btn-group">    
    <div class="content">

      <a class="btn" [routerLink]="'..'">
        <t-icon name="close"></t-icon>
        <span class="text">Annuler</span>
      </a>

    </div>
  </div>

</div>
<!-- /Toolbar -->

<table>

  <thead>
    <tr>
      <th style="width: 20px;"></th>
      <th style="width: 100px;">Version</th>
      <th>Nom</th>
      <th>Adresse</th>
      <th style="width: 320px">Créé par</th>
      <th style="width: 110px">Date d'ajout</th>
    </tr>
  </thead>

  <tbody *ngIf="entities && entities.length > 0">
    <tr *ngFor="let entity of entities" (click)="showSLEntityVersion(entity, $event)">
      <td class="icon-labels">
        <t-icon name="seal_check" *ngIf="entity.hasMovements" title="Avec un registre des mouvements"></t-icon>
      </td>
      <td style="width: 100px;" name="Version">
        {{ entity.version }}
      </td>
      <td name="Nom">
        {{ entity.name }}
      </td>
      <td name="Adresse">
        {{ entity.address | sladdress }}
      </td>
      <td name="Créée par" style="width: 320px">{{ entity.updatedBy.fullname }}</td>
      <td name="Date d'ajout" style="width: 110px">
        {{ entity.updatedAt | tzdate:'short' }}
      </td>
    </tr>
  </tbody>

  <tbody *ngIf="!entities || entities.length == 0">
    <tr>
      <td class="text-center" colspan="5">
        <ng-container *ngIf="entities && entities.length == 0">
          Aucune version n'a été trouvée
        </ng-container>
        <ng-container *ngIf="!entities">
          Chargement...
        </ng-container>
      </td>
    </tr>
  </tbody>

</table>
